import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store';

import './index.css';
import 'antd-css-utilities/utility.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Restoring session...</div>} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals();